import React from 'react';

// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/virtual';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/grid';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';

import {
  render,
  MARK_LINK,
  NODE_PARAGRAPH,
} from 'storyblok-rich-text-react-renderer';
import FancyTitle from '../fancy-title';
import LinkResolver from '../../helpers/link-resolver';

export default function TestimonialCardsContent({ blok }) {
  const { testimonials } = blok;
  const imageClasses = '';
  return (
    <div className="px-4 lg:px-16">
      <Swiper
        modules={[Pagination]}
        slidesPerView="auto"
        className="w-full testimonials-slider"
        centeredSlides
        loop
        spaceBetween={20}
        initialSlide={0}
        pagination={{
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className}">${index + 1}</span>`;
          },
        }}
        breakpoints={{
          320: {
            slidesPerView: 1,
          },
          1280: {
            slidesPerView: 3,
            initialSlide: 0,
          },
        }}
      >
        {testimonials
          && testimonials.length !== 0
          && testimonials.map((item) => {
            const image = item.logo.filename;
            const profile = item.profile_image.filename;
            const stars = 'https://www.latori.com/static/a1a6d47117cabc90d41ad645d00b9cc0/3065b/5-stars.avif';
            return (
              <SwiperSlide key={item._uid} className="!h-auto">
                <div className="border-2 rounded border-latori-green-dark p-6 lg:p-8 gap-2 lg:gap-4 flex flex-col justify-start items-center h-full">
                  {image && (
                    <img
                      src={image}
                      className={`${
                        image ? 'hidden dark:inline-block' : ''
                      } mb-5${imageClasses || ''}`}
                      alt={item.title}
                      // objectFit="contain"
                      style={{
                        maxWidth: '150px',
                        width: item.imageWidth || '',
                        height: item.imageWidth || '',
                      }}
                    />
                  )}
                  {image && (
                    <img
                      src={image}
                      className="dark:hidden mb-5"
                      // objectFit="contain"
                      alt={item.title}
                      style={{
                        maxWidth: '150px',
                        width: item.imageWidth || '',
                        height: item.imageWidth || '',
                      }}
                    />
                  )}
                  <div className="flex justify-center items-center gap-4">
                    {profile && (
                      <div className="bg-black p-[1px] rounded-full">
                        <img
                          src={profile}
                          alt={item.title}
                          // objectFit="contain"
                          className=" "
                          style={{
                            maxWidth: '60px',
                          }}
                        />
                      </div>
                    )}
                    <FancyTitle
                      tag="h3"
                      text={item.name}
                      fontSize="text-xl xl:text-2xl"
                      marginBottom="mb-0"
                      styleOverrides="fancy-title-testimonials"
                    />
                  </div>
                  <div className="xl:mt-4">
                    {stars && (
                      <img
                        src={stars}
                        alt={item.title}
                        // objectFit="contain"
                        className=" "
                      />
                    )}
                  </div>
                  <div className="xl:mt-4">
                    {render(item.content, {
                      markResolvers: {
                        [MARK_LINK]: LinkResolver,
                      },
                      nodeResolvers: {
                        // eslint-disable-next-line react/no-unstable-nested-components
                        [NODE_PARAGRAPH]: (children) => (
                          <p className="">{children}</p>
                        ),
                      },
                    })}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
}
